import ReactGA from "react-ga4";

import { faq_page_events } from "./Faq-page-events";
import { about_us_events } from "./aboutUs-events";
import { booking_page_events } from "./booking-page-events";
import { current_trips_events } from "./current-trips-events";
import { edit_profile_popup_events } from "./edit-profile-events";
import { explore_city_events } from "./explore-city-events";
import { flight_delay_events } from "./flight-delay-events";
import { flight_select_events } from "./flight-select-page-events";
import { home_and_sideBar_events } from "./home-and-sidebar-events";
import { home_page_events } from "./home-page-events";
import { itinerary_details_events } from "./itinerary-details-events";
import { itinerary_listing_events } from "./itinerary-listing-events";
import { login_popup_events } from "./login-events";
import { my_trips_events } from "./my-trips-events";
import { preview_preferences_events } from "./preview-preference-events";
import { trip_details_events } from "./trip-details-events";
import { weather_advisory_events } from "./weather-advisory-events";
import { consoleLog } from "../../utils/consoleLog/consoleLog";
import { booking_flights } from "./booking-flights";
import { booking_stays } from "./booking-stays";
import { traveler_form } from "./traveler-form";
import { capitalizeHyphenated } from "../../utils/stringManipulationUtils/trimAndReplaceSpaceWithDash";
import { on_boarding_events } from "./onboarding-events";
import { place_details_events } from "./place-details-event";
import { comments_events } from "./comments-events";
import { ab_testing_events } from "./ab-testing-events";
import { fetchApi } from "../../utils/apiFunction";
import { API_METHODS } from "../../enums";
import { endPoints } from "../api_constants/url";
import { getItemFromSessionStorage, setItemInSessionStorage } from "../../hooks/sessionStorage";
import { getSessionId } from "../../utils/sessionId";
import { environment, ENABLE_GA_CUSTOM_EVENTS } from "../environment";
import { decryptData } from "../../utils/api/encryption";
import { ENVIRONMENT_TYPE } from "../common";

// Module-level cache for the current logged-in user's email. React keeps this
// in sync with StateContext.userInfo (see useSyncCurrentUserEmail in App.tsx).
// `getUserInfo` inside triggerGAEvent / usePixelEvent reads from localStorage,
// which can be stale or empty at the moment an event fires (e.g. booking-form-
// flights-search-click was firing without email even for logged-in users,
// breaking the Mailchimp uploader). This cache is the authoritative fallback.
let _currentUserEmail = "";
export const setCurrentUserEmail = (email: string | null | undefined) => {
  _currentUserEmail = email || "";
};
export const getCurrentUserEmail = () => _currentUserEmail;

export enum GA_LABEL_ENUMS {
  Cancel_LLM_Streaming = "Cancel_LLM_Streaming",
  // home page events
  chat_places_to_visit_card_click = "chat_places_to_visit_card_click",
  chat_showmore_click = "Show_more_click",
  chat_itinerary_book_click = "chat_itinerary_book_click",
  home_side_bar_open_click = "home_side_bar_open_click",
  home_side_bar_close_click = "home_side_bar_close_click",
  home_preferences_click = "home_preferences_click",
  home_chat_input_click = "home_chat_input_click",
  home_suggestion_click = "home_suggestion_click",
  home_four_trip_suggestions_generated = "home_four_trip_suggestions_generated",
  onboarding_itinerary_creation_auto = "onboarding_itinerary_creation_auto",
  home_chat_try_again_click = "home_chat_try_again_click",

  // navbar and side bar events
  Terms_of_service_click = "Terms_of_service_click",
  sidebar_get_help = "sidebar_get_help",
  get_help_input_name = "get_help_input_name",
  get_help_input_email = "get_help_input_email",
  get_help_input_phone = "get_help_input_phone",
  get_help_issue_type = "get_help_issue_type",
  get_help_input_message = "get_help_input_message",
  get_help_close = "get_help_close",
  get_help_send = "get_help_send",

  sidebar_contact_us = "sidebar_contact_us",
  sidebar_chat_with_us = "sidebar_chat_with_us",
  Login_in_click = "Login_in_click",
  Signup_in_click = "Signup_in_click",
  signup_switch_click = "signup_switch_click",
  login_switch_click = "login_switch_click",
  signup_close = "signup_close",
  google_signup_click = "google_signup_click",
  apple_signup_click = "apple_signup_click",
  facebook_signup_click = "facebook_signup_click",
  signup_with_email_click = "signup_with_email_click",
  signup_with_email_submit_click = "signup_with_email_submit_click",
  signup_with_email_back_click = "signup_with_email_back_click",
  signup_with_email_close_click = "signup_with_email_close_click",
  signup_with_email_input_email = "signup_with_email_input_email",
  signup_with_email_input_password = "signup_with_email_input_password",

  My_trips_click = "My_trips_click",
  saved_trips_click = "saved_trips_click",
  Current_trips_click = "Current_trips_click",
  History_click = "History_click",
  History_delete_click = "History_delete_click",
  Privacy_polcy_click = "Privacy_polcy_click",
  Logout = "Logout",

  login_with_email_click = "login_with_email_click",
  login_with_email_input_email = "login_with_email_input_email",
  login_with_email_input_password = "login_with_email_input_password",
  login_close = "login_close",
  signup_with_email_input_name = "signup_with_email_input_name",
  login_with_email_sign_up_click = "login_with_email_sign_up_click",
  login_back_click = "login_back_click",
  login_with_email_back_click = "login_with_email_back_click",
  reset_password_back_click = "reset_password_back_click",
  login_signup_cta_click = "login_signup_cta_click",
  login_with_email_close_click = "login_with_email_close_click",
  Login_reset_password_email_input_click = "Login_reset_password_email_input_click",
  // login poup events
  Google_login_click = "Google_login_click",
  Apple_login_click = "Apple_login_click",
  Facebook_login_click = "Facebook_login_click",
  Forgot_password_click = "Forgot_password_click",
  Forgot_password_send_link_click = "Forgot_password_send_link_click",
  login_reset_password_back_click = "login_reset_password_back_click",
  Create_new_account_click = "Create_new_account_click",
  Login_with_email_submit = "Login_with_email_submit",
  signup_complete = "signup_complete",
  signup_complete_google = "signup_complete_google",
  signup_complete_apple = "signup_complete_apple",
  signup_complete_facebook = "signup_complete_facebook",
  signup_complete_email = "signup_complete_email",

  log_in_success_google = "log_in_success_google",
  log_in_success_apple = "log_in_success_apple",
  log_in_success_facebook = "log_in_success_facebook",
  log_in_success_email = "log_in_success_email",

  // sign up events
  Sign_up_with_email = "Sign_up_with_email",

  // edit account popup events
  home_edit_profile_click = "home_edit_profile_click",
  home_submit_edit_profile_click = "home_submit_edit_profile_click",
  home_delete_account_click = "home_delete_account_click",
  Profile_yes_delete_account_click = "Profile_yes_delete_account_click",
  Profile_delete_cancel_click = "Profile_delete_cancel_click",
  edit_profile_mobile_phone_input_field = "edit_profile_mobile_phone_input_field",
  edit_profile_name_input_field = "edit_profile_name_input_field",
  edit_profile_close_modal = "edit_profile_close_modal",
  edit_profile_your_name_click = "edit_profile_your_name_click",

  // my trips page events
  my_trips_page_load = "my_trips_page_load",
  back_my_trips = "back_my_trips",
  back_saved = "back_saved",
  back_history = "back_history",
  history_item_click = "history_item_click",
  my_trips_upcoming_tab_click = "my_trips_upcoming_tab_click",
  my_trips_past_tab_click = "my_trips_past_tab_click",
  my_trips_cancelled_tab_click = "my_trips_cancelled_tab_click",
  my_trips_shared_tab_click = "my_trips_shared_tab_click",
  my_trips_saved_tab_click = "my_trips_saved_tab_click",
  my_trips_upcoming_trips_card_click = "my_trips_upcoming_trips_card_click",
  my_trips_past_trips_card_click = "my_trips_past_trips_card_click",
  my_trips_cancelled_trips_card_click = "my_trips_cancelled_trips_card_click",
  my_trips_shared_trips_card_click = "my_trips_shared_trips_card_click",
  my_trips_saved_trips_card_click = "my_trips_saved_trips_card_click",
  saved_trips_edit_close_click = "saved_trips_edit_close_click",
  saved_trips_edit_name_click = "saved_trips_edit_name_click",
  saved_trips_edit_save_click = "saved_trips_edit_save_click",
  my_trips_upcoming_trips_edit_click = "my_trips_upcoming_trips_edit_click",
  edit_trip_new_trip_name_click = "edit_trip_new_trip_name_click",
  edit_trip_name_modal_close = "edit_trip_name_modal_close",
  my_trips_past_edit_trip_name_click = "my_trips_past_edit_trip_name_click",
  my_trips_past_name_save_click = "my_trips_past_name_save_click",
  my_trips_upc_edit_trip_name_close_click = "my_trips_upc_edit_trip_name_close_click",
  my_trips_past_edit_trip_name_close_click = "my_trips_past_edit_trip_name_close_click",
  my_trips_cnc_edit_trip_name_close_click = "my_trips_cnc_edit_trip_name_close_click",
  my_trips_shared_edit_trip_name_close_click = "my_trips_shared_edit_trip_name_close_click",
  my_trips_past_trips_edit_click = "my_trips_past_trips_edit_click",
  my_trips_cancelled_trips_edit_click = "my_trips_cancelled_trips_edit_click",
  my_trips_shared_trips_edit_click = "my_trips_shared_trips_edit_click",
  saved_trips_edit_click = "saved_trips_edit_click",
  my_trips_past_trips_book_again_click = "my_trips_past_trips_book_again_click",
  my_trips_cancelled_trips_book_again_click = "my_trips_cancelled_trips_book_again_click",
  my_trips_saved_trips_book_click = "my_trips_saved_trips_book_click",
  edit_trip_name_save_changes = "edit_trip_name_save_changes",
  my_trips_need_help = "my_trips_need_help",
  need_help_back_click = "need_help_back_click",
  need_help_email_us_click = "need_help_email_us_click",
  need_help_phone_click = "need_help_phone_click",

  // preview preferences events
  pref_my_location_option_click = "pref_my_location_option_click",
  preview_preference_load = "preview_preference_load",
  pref_my_location_clear = "pref_my_location_clear",
  preferences_modal_close_button = "preferences_modal_close_button",
  preferences_modal_home_city = "preferences_modal_home_city",
  preferences_modal_flight_stay_trip_preferences = "preferences_modal_flight_stay_trip_preferences",
  preferences_modal_budget_economy = "preferences_modal_budget_economy",
  preferences_modal_budget_mid_range = "preferences_modal_budget_mid_range",
  preferences_modal_luxury = "preferences_modal_luxury",
  preferences_dietary_restrictions_dropdown = "preferences_dietary_restrictions_dropdown",
  preferences_dietary_restrictions_option_click = "preferences_dietary_restrictions_option_click",
  pref_travel = "pref_travel",
  preferences_interests_dropdown = "preferences_interests_dropdown",
  preferences_interests_dropdown_option_click = "preferences_interests_dropdown_option_click",
  preferences_done_button = "preferences_done_button",

  //Edit Location
  edit_location = "edit_location",
  // current trips/today's page events
  current_trips_page_loads = "current_trips_page_loads",
  today_explore_city_click = "today_explore_city_click",
  today_view_trip_details_click = "today_view_trip_details_click",
  today_zenvoya_assistance_click = "today_zenvoya_assistance_click",
  today_zenvoya_assistance_input_click = "today_zenvoya_assistance_input_click",
  today_explore_city_input_click = "today_explore_city_input_click",

  // flight delay events
  flight_delay_page_load = "flight_delay_page_load",
  flight_delay_back_click = "flight_delay_back_click",
  flight_delay_details_click = "flight_delay_details_click",
  flight_delay_chat_showmore_click = "flight_delay_show_more_click",
  flight_delay_select_click = "flight_delay_select_click",

  // Flight select page events
  flight_select_page_load = "flight_select_page_load",
  flight_select_back_click = "flight_select_back_click",
  flight_select_selected_flight_accordion_click = "flight_select_selected_flight_accordion_click",
  flight_select_selected_flight_details_accordion_click = "flight_select_selected_flight_details_accordion_click",
  flight_select_selected_flight_collapse_accordion_click = "flight_select_selected_flight_collapse_accordion_click",
  flight_select_suggested_changes_your_plan_accordion_click = "flight_select_suggested_changes_your_plan_accordion_click",
  flight_select_suggested_changes_your_plan_checkbox_click = "flight_select_suggested_changes_your_plan_checkbox_click",
  flight_select_confirm_click = "flight_select_confirm_click",

  // weather advisory events
  weather_advisory_page_load = "weather_advisory_page_load",
  weather_advisory_back_click = "weather_advisory_back_click",
  weather_advisory_suggested_changes_your_plan_accordion_click = "weather_advisory_suggested_changes_your_plan_accordion_click",
  weather_advisory_suggested_changes_your_plan_checkbox_click = "weather_advisory_suggested_changes_your_plan_checkbox_click",
  weather_advisory_apply_changes_click = "weather_advisory_apply_changes_click",

  // Explore city evetns
  explore_city_page_load = "explore_city_page_load",
  explore_city_back_click = "explore_city_back_click",
  today_zenvoya_assistance_back_click = "today_zenvoya_assistance_back_click",
  today_explore_city_send = "today_explore_city_send",
  today_zenvoya_assistance_send = "today_zenvoya_assistance_send",

  //Home page
  home_zenvoya_logo_click = "home_zenvoya_logo_click",
  chat_input_field_send_prompt_to_llm_click = "chat_input_field_send_prompt_to_llm_click",
  chat_input_field_cancel_generating_llm_response = "chat_input_field_cancel_generating_llm_response",
  chat_input_field_start_mic_record = "chat_input_field_start_mic_record",
  chat_input_field_mic_stop_recording_click = "chat_input_field_mic_stop_recording_click",

  //Itinerary listing page
  chat_itinerary_card_click = "chat_itinerary_card_click",

  //Itinerary details page
  itinerary_details_cancel_click = "itinerary_details_cancel_click",
  itinerary_details_back_click = "itinerary_details_back_click",
  itinerary_details_save_click = "itinerary_details_save_click",
  itinerary_details_save_name_input = "itinerary_details_save_name_input",
  itinerary_details_save_itinerary_click = "itinerary_details_save_itinerary_click",
  itinerary_details_save_itinerary_Xclose_click = "itinerary_details_save_itinerary_Xclose_click",
  itinerary_details_share_click = "itinerary_details_share_click",
  itinerary_details_header_book_click = "itinerary_details_header_book_click",
  itinerary_details_footer_book_click = "itinerary_details_footer_book_click",
  itinerary_details_modify_activities_click = "itinerary_details_modify_activities_click",
  itinerary_details_activities_done_click = "itinerary_details_activities_done_click",
  itinerary_details_refine_click = "itinerary_details_refine_click",
  itinerary_details_book_only_flight_click = "itinerary_details_book_only_flight_click",
  itinerary_details_book_only_hotel_click = "itinerary_details_book_only_hotel_click",

  //FAQ page
  faqs_back_button_click = "faqs_back_button_click",
  privacy_policy_logo_click = "privacy_policy_logo_click",
  privacy_policy_back_click = "privacy_policy_back_click",
  tos_back_click = "tos_back_click",
  tos_logo_click = "tos_logo_click",
  faqs_back_downward_accordion_click = "faqs_back_downward_accordion_click",
  faqs_back_upward_accordion_click = "faqs_back_upward_accordion_click",

  //Side bar and nav bar

  //About-us page
  about_us_back_button_click = "about_us_back_button_click",
  about_us_try_it_now_button_click = "about_us_try_it_now_button_click",

  //Booking page
  booking_flight_checkbox_click = "booking_flight_checkbox_click",
  booking_hotel_checkbox_click = "booking_hotel_checkbox_click",
  booking_flight_hotel_checkbox_click = "booking_flight_hotel_checkbox_click",
  booking_flights_details_view_click = "booking_flights_details_view_click",
  booking_flights_details_view_close = "booking_flights_details_view_close",
  booking_flights_search_click = "booking_flights_search_click",
  booking_flights_search_login_click = "booking_flights_search_login_click",
  booking_stays_search_login_click = "booking_stays_search_login_click",
  booking_flights_cancel_search_click = "booking_flights_cancel_search_click",
  booking_flights_selecting_click = "booking_flights_selecting_click",
  booking_flights_select_fares_opt_click = "booking_flights_select_fares_opt_click",
  booking_flights_avail_cancel_click = "booking_flights_avail_cancel_click",
  booking_flights_avail_success = "booking_flights_avail_success",

  booking_payment_back_click = "booking_payment_back_click",
  booking_travelers_back_click = "booking_travelers_back_click",
  booking_review_cart_back_click = "booking_review_cart_back_click",
  review_cart_stays_details_view = "review_cart_stays_details_view",
  review_cart_stays_map_open_click = "review_cart_stays_map_open_click",
  review_cart_stays_map_close_click = "review_cart_stays_map_close_click",
  review_cart_stay_map_zoom_in_click = "review_cart_stay_map_zoom_in_click",
  review_cart_stays_map_zoom_out_click = "review_cart_stays_map_zoom_out_click",
  review_cart_stays_pic_change_click = "review_cart_stays_pic_change_click",
  review_cart_stays_amenities_open_click = "review_cart_stays_amenities_open_click",
  review_cart_stays_amenities_close_click = "review_cart_stays_amenities_close_click",
  review_cart_stays_slct_room_click = "review_cart_stays_slct_room_click",
  review_cart_stays_slct_rooms_close_click = "review_cart_stays_slct_rooms_close_click",
  review_cart_stays_room_dtls_open_click = "review_cart_stays_room_dtls_open_click",
  review_cart_stays_room_dtls_close_click = "review_cart_stays_room_dtls_close_click",
  review_cart_stays_more_rates_click = "review_cart_stays_more_rates_click",
  review_cart_stays_less_rates_click = "review_cart_stays_less_rates_click",
  review_cart_stays_cncl_plcy_open_click = "review_cart_stays_cncl_plcy_open_click",
  review_cart_stays_cncl_plcy_close_click = "review_cart_stays_cncl_plcy_close_click",
  review_cart_stays_room_pic_change_click = "review_cart_stays_room_pic_change_click",
  booking_stays_back_click = "booking_stays_back_click",
  booking_flights_back_click = "booking_flights_back_click",

  booking_discard_changes = "booking_discard_changes",
  booking_discard_cancel = "booking_discard_cancel",
  booking_stays_search_click = "booking_stays_search_click",
  booking_flights_search_click_auto = "booking_flights_search_click_auto",
  booking_stays_search_click_auto = "booking_stays_search_click_auto",
  booking_hotels_cancel_search_click = "booking_hotels_cancel_search_click",
  booking_hotels_selecting_click = "booking_hotels_selecting_click",
  post_booking_hotels_selecting_click = "post_booking_hotels_selecting_click",
  booking_stays_room_pic_change_click = "booking_stays_room_pic_change_click",
  booking_stays_avail_cancel_click = "booking_stays_avail_cancel_click",
  booking_stays_avail_success = "booking_stays_avail_success",
  booking_stays_pref_click = "booking_stays_pref_click",
  booking_stays_details_cancel_click = "booking_stays_details_cancel_click",
  booking_stays_details_pic_change_click = "booking_stays_details_pic_change_click",
  bookings_stays_amenities_close_click = "bookings_stays_amenities_close_click",
  booking_stays_less_rates_click = "booking_stays_less_rates_click",
  booking_stays_selecting_click = "booking_stays_selecting_click",
  booking_chat_activity_result_click = "booking_chat_activity_result_click",
  booking_chat_flight_stay_result_click = "booking_chat_flight_stay_result_click",
  booking_chat_flight_result_click = "booking_chat_flight_result_click",
  home_chat_tile_explore_places = "home_chat_tile_explore_places",
  booking_hotels_view_details_click = "booking_hotels_view_details_click",
  booking_hotels_view_room_details_click = "booking_hotels_view_room_details_click",

  booking_flight_ask_zoya = "booking_flight_ask_zoya",
  booking_hotel_ask_zoya = "booking_hotel_ask_zoya",
  booking_ask_zoya_sending_llm_question = "booking_ask_zoya_sending_llm_question",
  booking_ask_zoya_closed = "booking_ask_zoya_closed",
  booking_ask_zoya_input_click = "booking_ask_zoya_input_click",
  ask_zoya_prompt_click = "ask_zoya_prompt_click",
  ask_zoya_mic_record_click = "ask_zoya_mic_record_click",
  ask_zoya_mic_stop_record_click = "ask_zoya_mic_stop_record_click",
  ask_zoya_input_stop_click = "ask_zoya_input_stop_click",
  ask_zoya_scroll_down_click = "ask_zoya_scroll_down_click",
  ask_zoya_try_again_click = "ask_zoya_try_again_click",

  booking_selected_hotel_removed = "booking_selected_hotel_removed",
  booking_selected_flight_removed = "booking_selected_flight_removed",

  booking_stays_continue_click = "booking_stays_continue_click",
  booking_flights_continue_click = "booking_flights_continue_click",
  booking_review_cart_checkout_click = "booking_review_cart_checkout_click",
  booking_continue_to_traveler_click = "booking_continue_to_traveler_click",
  booking_travelers_continue_click = "booking_travelers_continue_click",
  review_cart_price_info_hover = "review_cart_price_info_hover",
  traveler_info_room_assignment_click = "traveler_info_room_assignment_click",

  booking_success = "booking_success",
  booking_failure = "booking_failure",
  payment_total_accordion_expand = "payment_total_accordion_expand",
  payment_total_accordion_collapse = "payment_total_accordion_collapse",
  booking_promo_code_input = "booking_promo_code_input",
  booking_promo_code_apply = "booking_promo_code_apply",
  booking_promo_code_success = "booking_promo_code_success",
  booking_promo_code_fail = "booking_promo_code_fail",
  booking_attempt = "booking_attempt",
  booking_promo_code_remove_success = "booking_promo_code_remove_success",
  booking_promo_code_remove_fail = "booking_promo_code_remove_fail",

  booking_cart_click = "booking_cart_click",
  payment_tos_accept_click = "payment_tos_accept_click",
  payment_info_message_us_click = "payment_info_message_us_click",
  // Booking flights
  booking_flights_search_refresh_click = "booking_flights_search_refresh_click",
  booking_flights_details_cancel_click = "booking_flights_details_cancel_click",
  booking_flights_preferences_click = "booking_flights_preferences_click",
  booking_flights_travelers_click = "booking_flights_travelers_click",
  booking_flights_route_class_click = "booking_flights_route_class_click",
  booking_form_flights_class_open_click = "booking_form_flights_class_open_click",
  booking_form_flights_route_close_click = "booking_form_flights_route_close_click",
  booking_form_flights_class_close_click = "booking_form_flights_class_close_click",
  booking_flights_route_from_click = "booking_flights_route_from_click",
  booking_flights_route_to_click = "booking_flights_route_to_click",
  booking_form_flights_origin_clear = "booking_form_flights_origin_clear",
  booking_form_flights_origin_option_click = "booking_form_flights_origin_option_click",
  booking_form_flights_switch_dest_click = "booking_form_flights_switch_dest_click",
  booking_form_flights_dest_clear = "booking_form_flights_dest_clear",
  booking_form_multi_city_rmv_dest_click = "booking_form_multi_city_rmv_dest_click",
  booking_form_flights_dest_option_click = "booking_form_flights_dest_option_click",
  booking_departur_date_click = "booking_departur_date_click",
  booking_return_date_click = "booking_return_date_click",
  booking_flights_preferences_refundable_click = "booking_flights_preferences_refundable_click",
  booking_flights_preferences_connections_click = "booking_flights_preferences_connections_click",
  booking_flights_preferences_preferred_airlines = "booking_flights_preferences_preferred_airlines",
  flights_pref_pref_airlines_option_click = "flights_pref_pref_airlines_option_click",
  flights_pref_pref_airlines_rmv_click = "flights_pref_pref_airlines_rmv_click",
  flights_pref_dep_times_clear_click = "flights_pref_dep_times_clear_click",
  flights_pref_dep_times_save_click = "flights_pref_dep_times_save_click",
  flights_pref_dep_times_cancel_click = "flights_pref_dep_times_cancel_click",
  booking_flights_preferences_close = "booking_flights_preferences_close",
  booking_flights_pref_click = "booking_flights_pref_click",
  booking_flights_preferences_done = "booking_flights_preferences_done",
  booking_flights_travelers_adults_add = "booking_flights_travelers_adults_add",
  booking_flights_travelers_adults_remove = "booking_flights_travelers_adults_remove",
  booking_flights_travelers_children_add = "booking_flights_travelers_children_add",
  booking_flights_travelers_children_remove = "booking_flights_travelers_children_remove",
  booking_flights_travelers_infants_in_seat_add = "booking_flights_travelers_infants_in_seat_add",
  booking_flights_travelers_infants_in_seat_remove = "booking_flights_travelers_infants_in_seat_remove",
  booking_flights_travelers_infants_on_lap_add = "booking_flights_travelers_infants_on_lap_add",
  booking_flights_travelers_infants_on_lap_remove = "booking_flights_travelers_infants_on_lap_remove",
  booking_flights_travelers_done_click = "booking_flights_travelers_done_click",
  booking_form_flights_traveler_cncl_click = "booking_form_flights_traveler_cncl_click",
  booking_flights_route_and_class_route_selected = "booking_flights_route_and_class_route_selected",
  booking_flights_route_and_class_class_selected = "booking_flights_route_and_class_class_selected",
  booking_flights_route_and_class_done = "booking_flights_route_and_class_done",
  booking_flights_preferences_departure_times_click = "booking_flights_preferences_departure_times_click",

  booking_flights_baggage_fare_rules = "booking_flights_baggage_fare_rules",
  booking_flights_baggage_fare_rules_close = "booking_flights_baggage_fare_rules_close",
  review_cart_flights_bag_rules_cls_click = "review_cart_flights_bag_rules_cls_click",
  booking_flights_cancellation_close = "booking_flights_cancellation_close",
  booking_flights_select_fares = "booking_flights_select_fares",
  booking_flights_select_fares_close = "booking_flights_select_fares_close",
  booking_flights_select_fares_cncl_click = "booking_flights_select_fares_cncl_click",

  // Booking hotels
  booking_stays_search_refresh_click = "booking_stays_search_refresh_click",
  booking_stays_preferences_click = "booking_stays_preferences_click",
  booking_stays_preferences_refundable = "booking_stays_preferences_refundable",
  booking_stays_preferences_user_rating = "booking_stays_preferences_user_rating",
  booking_stays_preferences_star_rating_number = "booking_stays_preferences_star_rating_number",
  booking_stays_preferences_types_hotels = "booking_stays_preferences_types_hotels",
  stays_pref_star_rating_deslct_opt_click = "stays_pref_star_rating_deslct_opt_click",
  stays_pref_types_deselect_click = "stays_pref_types_deselect_click",
  stays_pref_brands_option_click = "stays_pref_brands_option_click",
  stays_pref_brands_clear = "stays_pref_brands_clear",

  booking_stays_preferences_hotel_brands_input_click = "booking_stays_preferences_hotel_brands_input_click",
  booking_stays_preferences_close = "booking_stays_preferences_close",
  booking_stays_preferences_done_click = "booking_stays_preferences_done_click",

  booking_stays_rooms_click = "booking_stays_rooms_click",
  booking_form_stays_view = "booking_form_stays_view",
  booking_form_flights_view = "booking_form_flights_view",
  booking_stays_rooms_adults_remove_click = "booking_stays_rooms_adults_remove_click",
  booking_stays_rooms_adults_add_click = "booking_stays_rooms_adults_add_click",
  booking_stays_rooms_children_add = "booking_stays_rooms_children_add",
  booking_stays_rooms_children_remove = "booking_stays_rooms_children_remove",
  booking_stays_rooms_add_another_room_click = "booking_stays_rooms_add_another_room_click",
  booking_stays_rooms_remove_click = "booking_stays_rooms_remove_click",
  booking_stays_rooms_done_click = "booking_stays_rooms_done_click",

  booking_stays_location_input_click = "booking_stays_location_input_click",
  booking_stays_checkin_date_click = "booking_stays_checkin_date_click",
  booking_stays_checkout_date_click = "booking_stays_checkout_date_click",
  booking_stays_add_a_stay_click = "booking_stays_add_a_stay_click",
  booking_form_stays_rooms_cancel_click = "booking_form_stays_rooms_cancel_click",
  booking_form_stays_location_clear = "booking_form_stays_location_clear",
  booking_form_stays_location_option_click = "booking_form_stays_location_option_click",
  booking_stays_remove_a_stay_click = "booking_stays_remove_a_stay_click",

  booking_stays_select_room_btn_click = "booking_stays_select_room_btn_click",
  booking_stays_select_room_close_click = "booking_stays_select_room_close_click",
  booking_stays_view_hotel_map = "booking_stays_view_hotel_map",

  booking_stays_view_hotel_map_close = "booking_stays_view_hotel_map_close",
  booking_stays_view_hotel_map_zoom_in = "booking_stays_view_hotel_map_zoom_in",
  booking_stays_view_hotel_map_zoom_out = "booking_stays_view_hotel_map_zoom_out",
  booking_stays_view_all_amenities = "booking_stays_view_all_amenities",
  booking_stays_view_room_details = "booking_stays_view_room_details",
  booking_stays_view_room_details_close = "booking_stays_view_room_details_close",
  booking_stays_view_more_rates = "booking_stays_view_more_rates",
  booking_stays_view_refundable_policies = "booking_stays_view_refundable_policies",
  booking_stays_view_refundable_policies_close = "booking_stays_view_refundable_policies_close",

  //Traveler info page
  booking_select_traveler_information_form_basic_info_first_name = "booking_select_traveler_information_form_basic_info_first_name",
  booking_select_traveler_information_form_basic_info_middle_name = "booking_select_traveler_information_form_basic_info_middle_name",
  booking_select_traveler_information_form_basic_info_last_name = "booking_select_traveler_information_form_basic_info_last_name",
  booking_select_traveler_information_form_basic_info_date_of_birth_month = "booking_select_traveler_information_form_basic_info_date_of_birth_month",
  traveler_info_basic_dob_mth_close_click = "traveler_info_basic_dob_mth_close_click",
  traveler_info_basic_dob_mth_option_click = "traveler_info_basic_dob_mth_option_click",
  booking_select_traveler_information_form_basic_info_date_of_birth_day = "booking_select_traveler_information_form_basic_info_date_of_birth_day",
  booking_select_traveler_information_form_basic_info_date_of_birth_year = "booking_select_traveler_information_form_basic_info_date_of_birth_year",
  booking_select_traveler_information_form_basic_info_gender = "booking_select_traveler_information_form_basic_info_gender",
  traveler_info_basic_gender_close_click = "traveler_info_basic_gender_close_click",
  traveler_info_basic_gender_option_click = "traveler_info_basic_gender_option_click",

  booking_select_traveler_information_contact_info_email = "booking_select_traveler_information_contact_info_email",
  booking_select_traveler_information_contact_info_country_code = "booking_select_traveler_information_contact_info_country_code",
  traveler_info_cntct_ctry_cd_close_click = "traveler_info_cntct_ctry_cd_close_click",
  traveler_info_cntct_ctry_cd_option_click = "traveler_info_cntct_ctry_cd_option_click",

  booking_select_traveler_information_contact_info_phone_number = "booking_select_traveler_information_contact_info_phone_number",

  booking_select_traveler_information_passport_issuing_country = "booking_select_traveler_information_passport_issuing_country",
  traveler_info_pport_ctry_option_click = "traveler_info_pport_ctry_option_click",
  traveler_info_pport_ctry_close_click = "traveler_info_pport_ctry_close_click",
  booking_select_traveler_information_passport_passport_number = "booking_select_traveler_information_passport_passport_number",
  booking_select_traveler_information_passport_nationality = "booking_select_traveler_information_passport_nationality",
  traveler_info_pport_natn_close_click = "traveler_info_pport_natn_close_click",
  traveler_info_pport_natn_option_click = "traveler_info_pport_natn_option_click",
  booking_select_traveler_information_passport_issue_date_month = "booking_select_traveler_information_passport_issue_date_month",
  traveler_info_pport_iss_mth_close_click = "traveler_info_pport_iss_mth_close_click",
  traveler_info_pport_iss_mth_option_click = "traveler_info_pport_iss_mth_option_click",
  booking_select_traveler_information_passport_issue_date_day = "booking_select_traveler_information_passport_issue_date_day",
  booking_select_traveler_information_passport_issue_date_year = "booking_select_traveler_information_passport_issue_date_year",
  booking_select_traveler_information_passport_expiration_date_month = "booking_select_traveler_information_passport_expiration_date_month",
  traveler_info_pport_exp_mth_close_click = "traveler_info_pport_exp_mth_close_click",
  traveler_info_pport_exp_mth_option_click = "traveler_info_pport_exp_mth_option_click",

  booking_select_traveler_information_passport_expiration_date_day = "booking_select_traveler_information_passport_expiration_date_day",
  booking_select_traveler_information_passport_expiration_date_year = "booking_select_traveler_information_passport_expiration_date_year",

  booking_select_traveler_information_additional_info_plus_click = "booking_select_traveler_information_additional_info_plus_click",
  booking_select_traveler_information_additional_info_close_click = "booking_select_traveler_information_additional_info_close_click",
  booking_select_traveler_information_additional_info_frequent_flyer_program_name = "booking_select_traveler_information_additional_info_frequent_flyer_program_name",
  booking_select_traveler_information_additional_info_frequent_flyer_number = "booking_select_traveler_information_additional_info_frequent_flyer_number",
  booking_select_traveler_information_additional_info_tsa_precheck_pass_id = "booking_select_traveler_information_additional_info_tsa_precheck_pass_id",
  booking_select_traveler_information_additional_info_tsa_precheck_redress_number = "booking_select_traveler_information_additional_info_tsa_precheck_redress_number",
  booking_select_traveler_information_additional_info_meal_preferences_meal_type = "booking_select_traveler_information_additional_info_meal_preferences_meal_type",
  traveler_info_add_info_meal_close_click = "traveler_info_add_info_meal_close_click",
  traveler_info_add_info_meal_option_click = "traveler_info_add_info_meal_option_click",
  booking_select_traveler_information_additional_info_special_assistance = "booking_select_traveler_information_additional_info_special_assistance",
  traveler_info_add_info_spcl_close_click = "traveler_info_add_info_spcl_close_click",
  traveler_info_add_info_spcl_option_click = "traveler_info_add_info_spcl_option_click",

  booking_select_traveler_open_recent_traveler_list = "booking_select_traveler_open_recent_traveler_list",
  traveler_info_recent_list_option_click = "traveler_info_recent_list_option_click",
  traveler_info_recent_list_close_click = "traveler_info_recent_list_close_click",
  booking_select_traveler_add_new_traveler = "booking_select_traveler_add_new_traveler",
  booking_select_traveler_edit_traveller = "booking_select_traveler_edit_traveller",
  booking_select_traveler_edit_traveler_save = "booking_select_traveler_edit_traveler_save",
  booking_select_traveler_edit_traveler_cancel = "booking_select_traveler_edit_traveler_cancel",
  booking_select_traveler_select_a_traveler_from_recent_traveler = "booking_select_traveler_select_a_traveler_from_recent_traveler",

  booking_room_assignment_open_recent_traveler_list = "booking_room_assignment_open_recent_traveler_list",
  booking_room_assignment_close_recent_traveler_list = "booking_room_assignment_close_recent_traveler_list",
  booking_room_assignment_add_new_traveller = "booking_room_assignment_add_new_traveller",
  booking_room_assignment_select_a_traveler_from_recent_traveller = "booking_room_assignment_select_a_traveler_from_recent_traveller",

  booking_save_collected_missing_info = "booking_save_collected_missing_info",
  booking_close_collected_missing_info = "booking_close_collected_missing_info",

  // Trip details page events
  trip_details_page_load = "trip_details_page_load",
  trip_details_flight_tab_load = "trip_details_flight_tab_load",
  trip_details_hotel_tab_load = "trip_details_hotel_tab_load",
  trip_details_back_click = "trip_details_back_click",
  trip_details_daily_activity_accordion_click = "trip_details_daily_activity_accordion_click",
  trip_details_flights_cancel_option_click = "trip_details_flights_cancel_option_click",
  trip_details_flights_change_flight_click = "trip_details_flights_change_flight_click",
  trip_details_flight_share_click = "trip_details_flight_share_click",
  trip_details_flight_help_click = "trip_details_flight_help_click",
  trip_details_flight_traveler_accordion_click = "trip_details_flight_traveler_accordion_click",
  trip_details_flight_payment_accordion_click = "trip_details_flight_payment_accordion_click",
  trip_details_hotel_cancel_option_click = "trip_details_hotel_cancel_option_click",
  trip_details_hotel_change_hotel_click = "trip_details_hotel_change_hotel_click",
  trip_details_hotel_share_click = "trip_details_hotel_share_click",
  trip_details_hotel_help_click = "trip_details_hotel_help_click",

  new_trip_click = "new_trip_click",
  new_trip_public_click = "new_trip_public_click",
  sidebar_profile_click = "sidebar_profile_click",
  book_without_itinerary_click = "book_without_itinerary_click",
  home_tile = "home_tile",
  itinerary_details_view_activity_details = "itinerary_details_view_activity_details",
  itinerary_details_close_activity_details = "itinerary_details_close_activity_details",
  itinerary_day_details_click = "itinerary_day_details_click",
  itinerary_day_details_click_close = "itinerary_day_details_click_close",
  itinerary_details_edit_daily_details_input_click = "itinerary_details_edit_daily_details_input_click",
  itinerary_details_edit_daily_details_input_clear_click = "itinerary_details_edit_daily_details_input_clear_click",
  itinerary_details_edit_close = "itinerary_details_edit_close",
  itinerary_act_list_option_click = "itinerary_act_list_option_click",
  itinerary_act_list_selection_close_click = "itinerary_act_list_selection_close_click",
  start_chat = "start_chat",
  startChat = "startChat",
  appLoaded = "appLoaded",
  signUp = "signUp",
  viewItinerary = "viewItinerary",
  searchFlights = "searchFlights",
  searchStays = "searchStays",
  selectFlights = "selectFlights",
  selectStays = "selectStays",
  reviewCart = "reviewCart",
  promoCode = "promoCode",
  paymentComplete = "paymentComplete",
  login = "login",
  productLoaded = "productLoaded",
  interactedWithChat = "interactedWithChat",
  booking_promo_code_remove_click = "booking_promo_code_remove_click",

  // Onboarding
  onboarding_start_for_free_click = "onboarding_start_for_free_click",
  onboarding_log_in_click = "onboarding_log_in_click",
  onboarding_hight_intent_log_in_click = "onboarding_hight_intent_log_in_click",
  onboarding_home_city_input = "onboarding_home_city_input",
  onboarding_home_city_input_clear = "onboarding_home_city_input_clear",
  onboarding_home_city_select_city_click = "onboarding_home_city_select_city_click",
  onboarding_home_city_next_click = "onboarding_home_city_next_click",
  onboarding_home_city_back_click = "onboarding_home_city_back_click",
  onboarding_travel = "onboarding_travel",
  onboarding_travel_back_click = "onboarding_travel_back_click",
  onboarding_travel_next_click = "onboarding_travel_next_click",
  onboarding_vibe = "onboarding_vibe",
  onboarding_vibe_back_click = "onboarding_vibe_back_click",
  onboarding_vibe_next_click = "onboarding_vibe_next_click",
  onboarding_budget = "onboarding_budget",
  onboarding_budget_back_click = "onboarding_budget_back_click",
  onboarding_budget_next_click = "onboarding_budget_next_click",

  payment_pay_failure = "payment_pay_failure",

  // Review Cart page events
  review_cart_cancel_policy_open_click = "review_cart_cancel_policy_open_click",
  review_cart_cancel_policy_close_click = "review_cart_cancel_policy_close_click",
  review_cart_logo_click = "review_cart_logo_click",
  review_cart_leave_close_click = "review_cart_leave_close_click",
  review_cart_leave_cancel_click = "review_cart_leave_cancel_click",
  review_cart_leave_leave_click = "review_cart_leave_leave_click",
  review_cart_need_help_click = "review_cart_need_help_click",
  review_cart_need_help_message_click = "review_cart_need_help_message_click",
  review_cart_bottom_drawer_open = "review_cart_bottom_drawer_open",
  review_cart_bottom_drawer_close = "review_cart_bottom_drawer_close",

  // Traveler Info page events
  traveler_info_mod_stays_click = "traveler_info_mod_stays_click",
  traveler_info_mod_stays_close_click = "traveler_info_mod_stays_close_click",
  traveler_info_mod_stays_cncl_click = "traveler_info_mod_stays_cncl_click",
  traveler_info_mod_stays_cart_click = "traveler_info_mod_stays_cart_click",
  traveler_info_mod_flight_click = "traveler_info_mod_flight_click",
  traveler_info_mod_flight_close_click = "traveler_info_mod_flight_close_click",
  traveler_info_mod_flight_cncl_click = "traveler_info_mod_flight_cncl_click",
  traveler_info_mod_flight_cart_click = "traveler_info_mod_flight_cart_click",
  traveler_info_logo_click = "traveler_info_logo_click",
  traveler_info_leave_close_click = "traveler_info_leave_close_click",
  traveler_info_leave_cancel_click = "traveler_info_leave_cancel_click",
  traveler_info_whats_this_for_open_click = "traveler_info_whats_this_for_open_click",
  traveler_info_whats_this_for_close_click = "traveler_info_whats_this_for_close_click",

  // Payment page events
  payment_tos_click = "payment_tos_click",
  payment_mod_stays_click = "payment_mod_stays_click",
  payment_mod_stays_close_click = "payment_mod_stays_close_click",
  payment_mod_stays_cncl_click = "payment_mod_stays_cncl_click",
  payment_mod_stays_cart_click = "payment_mod_stays_cart_click",
  payment_mod_flight_click = "payment_mod_flight_click",
  payment_mod_flight_close_click = "payment_mod_flight_close_click",
  payment_mod_flight_cncl_click = "payment_mod_flight_cncl_click",
  payment_mod_flight_cart_click = "payment_mod_flight_cart_click",
  payment_logo_click = "payment_logo_click",
  payment_leave_close_click = "payment_leave_close_click",
  payment_leave_cancel_click = "payment_leave_cancel_click",
  payment_leave_leave_click = "payment_leave_leave_click",
  payment_bottom_drawer_open_click = "payment_bottom_drawer_open_click",
  payment_bottom_drawer_close_click = "payment_bottom_drawer_close_click",
  traveler_info_bottom_drawer_open = "traveler_info_bottom_drawer_open",
  traveler_info_bottom_drawer_close = "traveler_info_bottom_drawer_close",

  // Viral data (Who's coming with you) events
  viral_data_add_traveler_click = "viral_data_add_traveler_click",
  viral_data_do_it_later_click = "viral_data_do_it_later_click",
  viral_data_first_name_input_click = "viral_data_first_name_input_click",
  viral_data_last_name_input_click = "viral_data_last_name_input_click",
  viral_data_email_input_click = "viral_data_email_input_click",
  viral_data_remove_traveler_click = "viral_data_remove_traveler_click",
  viral_data_accordion_expand = "viral_data_accordion_expand",
  viral_data_accordion_collapse = "viral_data_accordion_collapse",
  viral_data_add_to_trip_click = "viral_data_add_to_trip_click",

  // Place details and restaurant list events
  itinerary_act_tab_overview_click = "itinerary_act_tab_overview_click",
  itinerary_act_tab_about_click = "itinerary_act_tab_about_click",
  itinerary_act_tab_reviews_click = "itinerary_act_tab_reviews_click",
  itinerary_act_image_select_click = "itinerary_act_image_select_click",
  itinerary_details_image_select_click = "itinerary_details_image_select_click",
  itinerary_act_details_close_click = "itinerary_act_details_close_click",
  itinerary_act_details_activity_view_click = "itinerary_act_details_activity_view_click",

  // Itinerary engagement bar + comments feature. Metadata in
  // comments-events.ts; enum strings here must match the keys in that file.
  itinerary_details_itinerary_like = "itinerary_details_itinerary_like",
  itinerary_details_itinerary_dislike = "itinerary_details_itinerary_dislike",
  itinerary_details_itinerary_comment = "itinerary_details_itinerary_comment",
  itinerary_comment_like = "itinerary_comment_like",
  itinerary_comment_dislike = "itinerary_comment_dislike",
  itinerary_comment_reply = "itinerary_comment_reply",
  itinerary_comment_options_click = "itinerary_comment_options_click",
  itinerary_comment_options_edit_click = "itinerary_comment_options_edit_click",
  itinerary_comment_options_delete_click = "itinerary_comment_options_delete_click",
  itinerary_comment_options_delete_yes = "itinerary_comment_options_delete_yes",
  itinerary_comment_options_delete_no = "itinerary_comment_options_delete_no",
  itinerary_comment_options_delete_close = "itinerary_comment_options_delete_close",
  itinerary_comment_show_replies_click = "itinerary_comment_show_replies_click",
  itinerary_comment_hide_replies_click = "itinerary_comment_hide_replies_click",
  itinerary_comment_input_click = "itinerary_comment_input_click",
  itinerary_comment_input_cancel_click = "itinerary_comment_input_cancel_click",
  itinerary_comment_input_post_click = "itinerary_comment_input_post_click",
  itinerary_comment_edit_input_click = "itinerary_comment_edit_input_click",
  itinerary_comment_edit_cancel_click = "itinerary_comment_edit_cancel_click",
  itinerary_comment_edit_post_click = "itinerary_comment_edit_post_click",
  itinerary_comment_edit_cancel_x_click = "itinerary_comment_edit_cancel_x_click",
  itinerary_comment_reply_input_click = "itinerary_comment_reply_input_click",
  itinerary_comment_reply_cancel_click = "itinerary_comment_reply_cancel_click",
  itinerary_comment_reply_post_click = "itinerary_comment_reply_post_click",
  itinerary_comment_reply_cancel_x_click = "itinerary_comment_reply_cancel_x_click",

  // A/B testing — exposure (fired when a user is bucketed and renders the
  // assigned variant) and conversion (existing click events tagged with
  // experiment_id + variant_id via the custom_object 5th arg). Metadata in
  // ab-testing-events.ts.
  ab_experiment_exposure = "ab_experiment_exposure",
  ab_experiment_conversion = "ab_experiment_conversion",
}

export const GA_EVENTS: any = {
  ...on_boarding_events,
  ...traveler_form,
  ...booking_stays,
  ...booking_flights,
  ...home_and_sideBar_events,
  ...login_popup_events,
  ...edit_profile_popup_events,
  // sign up event
  Sign_up_with_email: {
    category: "User signing up with email and password",
    action: "User clicks on create account to sign up with email and password",
    label: "Sign-up-with-email",
  },
  ...home_page_events,
  ...my_trips_events,
  ...preview_preferences_events,
  ...current_trips_events,
  ...flight_delay_events,
  ...flight_select_events,
  ...weather_advisory_events,
  ...explore_city_events,
  ...trip_details_events,
  ...itinerary_listing_events,
  ...itinerary_details_events,
  ...comments_events,
  ...ab_testing_events,
  ...faq_page_events,
  ...about_us_events,
  ...booking_page_events,
  ...place_details_events,
};

// Helper function to fetch geolocation data once per session
// let geolocationPromise: Promise<any> | null = null;

// const getGeolocation = async (): Promise<any> => {
//   // Check if geolocation is already cached in sessionStorage
//   const cachedGeolocation = getItemFromLocalStorage("_zenvoya_geolocation");
//   if (cachedGeolocation) {
//     return cachedGeolocation;
//   }

//   // If already fetching, return the existing promise
//   if (geolocationPromise) {
//     return geolocationPromise;
//   }

//   // Create a new promise to fetch geolocation
//   geolocationPromise = (async () => {
//     try {
//       const response = await fetchApi("", endPoints.geolocation, API_METHODS.POST, {});

//       if (response && response.data) {
//         // Cache the result in sessionStorage
//         const geolocationData = response?.data?.fullData?.location || {};
//         geolocationData.ipv4 = response?.data?.fullData?.ip || "";
//         setItemInLocalStorage("_zenvoya_geolocation", geolocationData);
//         consoleLog(["Geolocation fetched and cached:", geolocationData]);
//         return geolocationData;
//       }
//       return null;
//     } catch (error) {
//       consoleLog(["Error fetching geolocation:", error]);
//       return null;
//     } finally {
//       // Reset the promise after completion
//       geolocationPromise = null;
//     }
//   })();

//   return geolocationPromise;
// };

// Helper function to get and cache page referrer
const getPageReferrer = (): string => {
  // Check if referrer is already cached in sessionStorage
  const cachedReferrer = getItemFromSessionStorage("_zenvoya_page_referrer");
  if (cachedReferrer) {
    return cachedReferrer;
  }

  // Get the current referrer from document
  const currentReferrer = document.referrer || "";

  // Cache it for future use
  if (currentReferrer) {
    setItemInSessionStorage("_zenvoya_page_referrer", currentReferrer);
    consoleLog(["Page referrer cached:", currentReferrer]);
  }

  return currentReferrer;
};

export const triggerGAEvent = (
  GAlabel: GA_LABEL_ENUMS,
  custom_label?: string,
  custom_action?: string,
  preAction?: string,
  custom_object?: any
) => {
  const { category = "", action = "", label = "" } = GA_EVENTS[GAlabel] || {};
  let newLabel = action.length > 0 ? action + (custom_label ? ` ${custom_label}` : "") : custom_label;
  if (custom_label) newLabel = custom_label;
  const labelString =
    (preAction ? preAction : "") + label + (custom_action ? `-${custom_action?.replaceAll(" ", "-")}` : "");
  const labelSubstring = labelString.includes("-") ? labelString.toLowerCase() : labelString;
  consoleLog([
    "GA EVENTS",
    capitalizeHyphenated(
      (
        (preAction ? preAction : "") +
        label +
        (custom_action ? `-${custom_action?.replaceAll(" ", "-")}` : "")
      ).substring(0, 40)
    ),
    labelSubstring,
    "CUSTOM OBJECT",
    custom_object,
    // "LABEL", newLabel
  ]);

  consoleLog([
    "GAE",
    {
      category,
      action: (preAction ? preAction : "") + label + (custom_action ? `-${custom_action?.replaceAll(" ", "-")}` : ""),
      label: newLabel,
    },
  ]);

  // GA4 custom events gated by REACT_APP_ENABLE_GA_CUSTOM_EVENTS; auto events always fire.
  if (ENABLE_GA_CUSTOM_EVENTS) {
    try {
      ReactGA.event({
        category,
        action: (preAction ? preAction : "") + label + (custom_action ? `-${custom_action?.replaceAll(" ", "-")}` : ""),
        label: newLabel,
      });
    } catch (e) {
      consoleLog(e);
    }
  }

  // Send event to Facebook Pixel Event API
  (async () => {
    try {
      // const eventName = GAlabel;

      // Fetch geolocation (will be cached after first call)
      // const geoLocation = await getGeolocation();

      // Determine app identifier based on hostname
      const hostname = window.location.hostname;
      let app = "app-dev.zenvoya.ai";
      if (hostname.includes("app-dev")) {
        app = "app-dev.zenvoya.ai";
      } else if (hostname.includes("app-prompt")) {
        app = "app-prompt.zenvoya.ai";
      } else if (hostname.includes("app-patient")) {
        app = "app-pat.zenvoya.ai";
      } else if (hostname.includes("app-booking-test")) {
        app = "app-booking-test.zenvoya.ai";
      } else if (hostname.includes("chat")) {
        app = "chat.zenvoya.ai";
      }
      // Note: For native iOS app, this would need to be set differently

      // Extract GA session information from cookies (cached)
      const getGASessionInfo = () => {
        const customSessionId = getSessionId();

        // Check if session info is already cached
        const cachedSessionInfo = getItemFromSessionStorage("_zenvoya_ga_session_info");
        if (cachedSessionInfo) {
          if (!cachedSessionInfo.session_id) {
            cachedSessionInfo.session_id = customSessionId;
            setItemInSessionStorage("_zenvoya_ga_session_info", cachedSessionInfo);
          }
          return cachedSessionInfo;
        }

        try {
          // GA4 stores session info in _ga cookie
          const gaCookie = document.cookie.split("; ").find((row) => row.startsWith("_ga="));

          if (gaCookie) {
            const gaValue = gaCookie.split("=")[1];
            // GA cookie format: GA1.1.{client_id}.{timestamp}
            const parts = gaValue.split(".");
            if (parts.length >= 4) {
              const sessionId = parseInt(parts[3]) || Date.now();

              // Try to get session count from _ga_{measurement_id} cookie or default to 1
              const gaSessionCookie = document.cookie.split("; ").find((row) => row.startsWith("_ga_"));

              let sessionNumber = 1;
              if (gaSessionCookie) {
                const sessionValue = gaSessionCookie.split("=")[1];
                // Session cookie format: GS1.1.{session_start}.{session_count}.{engagement}.{timestamp}
                const sessionParts = sessionValue.split(".");
                if (sessionParts.length >= 4) {
                  sessionNumber = parseInt(sessionParts[3]) || 1;
                }
              }

              const sessionInfo = {
                ga_session_id: sessionId,
                ga_session_number: sessionNumber,
                session_id: customSessionId,
              };

              // Cache the session info
              setItemInSessionStorage("_zenvoya_ga_session_info", sessionInfo);
              return sessionInfo;
            }
          }
        } catch (e) {
          consoleLog(["Error extracting GA session info:", e]);
        }

        // Fallback values
        const fallbackSessionInfo = {
          ga_session_id: Date.now(),
          ga_session_number: 1,
          session_id: customSessionId,
        };

        // Cache the fallback values too
        setItemInSessionStorage("_zenvoya_ga_session_info", fallbackSessionInfo);
        return fallbackSessionInfo;
      };

      const sessionInfo = getGASessionInfo();

      // Extract user information
      const getUserInfo = () => {
        const userObj: any = {};

        // Get GA4 Client ID (user_pseudo_id) from _ga cookie
        try {
          // Check if user_pseudo_id is already cached in sessionStorage
          const cachedUserPseudoId = getItemFromSessionStorage("_zenvoya_user_pseudo_id");
          if (cachedUserPseudoId) {
            userObj.user_pseudo_id = cachedUserPseudoId;
          } else {
            // Try to extract from _ga cookie
            const gaCookie = document.cookie.split("; ").find((row) => row.startsWith("_ga="));
            if (gaCookie) {
              const gaValue = gaCookie.split("=")[1];
              // GA cookie format: GA1.1.{client_id}.{timestamp}
              // user_pseudo_id should be in format: {client_id}.{timestamp}
              const parts = gaValue.split(".");
              if (parts.length >= 4) {
                const userPseudoId = `${parts[2]}.${parts[3]}`;
                userObj.user_pseudo_id = userPseudoId;
                // Cache the user_pseudo_id for future use
                setItemInSessionStorage("_zenvoya_user_pseudo_id", userPseudoId);
                consoleLog(["User pseudo ID extracted and cached:", userPseudoId]);
              }
            } else {
              consoleLog(["GA cookie not yet available, user_pseudo_id will be missing"]);
            }
          }
        } catch (e) {
          consoleLog(["Error extracting GA Client ID:", e]);
        }

        // Get user email from localStorage if user is logged in
        try {
          const userInfoStr = localStorage.getItem("user_info");
          if (userInfoStr) {
            if (environment === ENVIRONMENT_TYPE.LOCAL) {
              const userInfo = JSON.parse(userInfoStr);
              if (userInfo && userInfo.email) {
                userObj.email = userInfo.email;
              }
            } else {
              const userInfo = decryptData(userInfoStr);
              if (userInfo && userInfo.email) {
                userObj.email = userInfo.email;
              }
            }
          }
        } catch (e) {
          consoleLog(["Error extracting user email:", e]);
        }

        // Fallback to in-memory cache (kept in sync with StateContext.userInfo
        // by the React tree) if localStorage read didn't yield an email.
        if (!userObj.email && _currentUserEmail) {
          userObj.email = _currentUserEmail;
        }

        // Only return user object if we have at least one field
        return Object.keys(userObj).length > 0 ? userObj : null;
      };

      const userInfo = getUserInfo();

      const payload: any = {
        event_name: labelSubstring,
        sent_at: Math.floor(Date.now() * 1000),
        event_source_url: window.location.href,
        custom: custom_object || {},
        // custom: {
        //   category,
        //   action:
        //     (preAction ? preAction : "") + label + (custom_action ? `-${custom_action?.replaceAll(" ", "-")}` : ""),
        //   label: labelSubstring,
        // },
        max_touch_points: navigator.maxTouchPoints || 0,
        context: {
          app: app,
          page_location: window.location.href,
          page_referrer: getPageReferrer(),
          page_title: document.title || "",
          page_path: window.location.pathname,
          _fbc: getItemFromSessionStorage("fbcId") || "",
          _gclid: getItemFromSessionStorage("gclid") || "",
          _gbraid: getItemFromSessionStorage("gbraid") || "",
          _fbp:
            document.cookie
              .split("; ")
              .find((row) => row.startsWith("_fbp="))
              ?.split("=")[1] || "",
          browser_id:
            document.cookie
              .split("; ")
              .find((row) => row.startsWith("_fbp="))
              ?.split("=")[1] || "", // Meta browser ID is the _fbp cookie value
          _fprom_tid:
            getItemFromSessionStorage("_fprom_tid") ||
            document.cookie
              .split("; ")
              .find((row) => row.startsWith("_fprom_tid="))
              ?.split("=")[1] ||
            "",
        },
        session: sessionInfo,
        env: environment === "production" ? "PROD" : "DEV",
        type: "lambda",
      };

      // Add user object only if we have user information
      if (userInfo) {
        payload.user = userInfo;
      }

      // Helper function to remove empty keys
      const removeEmptyKeys = (obj: any): any => {
        if (Array.isArray(obj)) {
          return obj.map(removeEmptyKeys).filter((v) => v !== null && v !== undefined);
        }
        if (obj !== null && typeof obj === "object") {
          return Object.entries(obj).reduce((acc: any, [key, value]) => {
            const cleanedValue = removeEmptyKeys(value);
            if (
              cleanedValue !== null &&
              cleanedValue !== undefined &&
              cleanedValue !== "" &&
              !(typeof cleanedValue === "object" && Object.keys(cleanedValue).length === 0)
            ) {
              acc[key] = cleanedValue;
            }
            return acc;
          }, {});
        }
        return obj;
      };

      // Remove empty keys before sending
      const cleanedPayload = removeEmptyKeys(payload);
      // cleanedPayload.geolocation = geoLocation;

      consoleLog(["Sending GA event to LAMBDA API:", labelSubstring, cleanedPayload]);

      // Note: accessJWT might not be available in this context
      // You may need to pass it as a parameter or retrieve it from localStorage/context

      await fetchApi("", endPoints.facebookPixel, API_METHODS.POST, {
        eventName: labelSubstring,
        eventData: cleanedPayload,
        bypassJWTValidation: true,
        // geoLocation: geoLocation,
      }).catch((error) => {
        consoleLog(["Failed to send GA event to Pixel API:", error]);
      });
    } catch (e) {
      consoleLog(["Error sending to Pixel API:", e]);
    }
  })();
};
